/**
 * Where an ADMIN opens one course.
 *
 * Two pages show a course to an admin: the editor (`/lms/courses/<id>/edit`,
 * route rule update:Course, lib/auth/nav-permissions.ts) and the live view
 * (`/lms/courses/<id>/live`, open on read:Course). `/lms/courses/<id>` is NOT
 * one of them: it is the LEARNER's entry (language chooser, then the player),
 * which tells an admin "This training can't be opened directly".
 *
 * Browser QA as nine roles (2026-10-06): every course title, cover, "View
 * details" and card linked to the editor, which the route gate refuses to a
 * role that may only read, so such a role could never open a course at all.
 * A role that may open the editor still goes there; any other role goes to the
 * live view.
 */

/** The editor's page, as the route rules key it: `[id]` matches any course id. */
export const COURSE_EDITOR_ROUTE = '/lms/courses/[id]/edit'

/** The course editor, optionally on one of its tabs (`?tab=`, see lib/lms/course-edit-tab.ts). */
export function courseEditHref(courseId: string, tab?: string): string {
  const base = `/lms/courses/${encodeURIComponent(courseId)}/edit`
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base
}

/** The course's live view: open to every role that may read courses. */
export function courseLiveHref(courseId: string): string {
  return `/lms/courses/${encodeURIComponent(courseId)}/live`
}

/** The course page an admin opens: the editor when the role may open it, else the live view. */
export function courseAdminHref(courseId: string, canOpenEditor: boolean): string {
  return canOpenEditor ? courseEditHref(courseId) : courseLiveHref(courseId)
}
